import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'app/shared/i18n';

export const Tools = () => {
  const { t } = useTranslation();

  const tools = [
    { name: 'Check Mail', desc: t('tools.checkMailDesc'), icon: '✉️', color: '#3B82F6', href: '/check-live-mail' },
    { name: 'Get Code', desc: t('tools.getCodeDesc'), icon: '🔑', color: '#8B5CF6', href: '/get-code-mail' },
    { name: t('tools.readMailbox'), desc: t('tools.readMailboxDesc'), icon: '📬', color: '#EC4899', href: '/read-mail-box' },
    { name: 'Check UID', desc: t('tools.checkUidDesc'), icon: '👤', color: '#06B6D4', href: '/check-live-uid' },
    { name: 'Get 2FA', desc: t('tools.get2faDesc'), icon: '🛡️', color: '#10B981', href: '/get2fa' },
    { name: t('tools.registerMail'), desc: t('tools.registerMailDesc'), icon: '📝', color: '#F59E0B', href: '/register-mail' },
    { name: 'Unlock Mail', desc: t('tools.unlockMailDesc'), icon: '🔓', color: '#EF4444', href: '/unlock-mail' },
    { name: t('tools.registerYahoo'), desc: t('tools.registerYahooDesc'), icon: '📨', color: '#8B5CF6', href: '/register-yahoo' },
  ];

  return (
    <section style={{ padding: '20px 24px 40px' }}>
      <div style={{ maxWidth: 1280, margin: '0 auto' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 24 }}>
          <h2 style={{ fontSize: 22, fontWeight: 700, margin: 0 }}>{t('tools.title')}</h2>
          <span className="ms-badge ms-badge--info">8 tools</span>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: 12 }}>
          {tools.map((tool, i) => (
            <Link
              key={i}
              to={tool.href}
              className="ms-tool-card"
              style={{ textDecoration: 'none' }}
              onMouseEnter={e => {
                (e.currentTarget as HTMLElement).style.borderColor = tool.color + '55';
                (e.currentTarget as HTMLElement).style.boxShadow = `0 8px 30px ${tool.color}15`;
              }}
              onMouseLeave={e => {
                (e.currentTarget as HTMLElement).style.borderColor = '';
                (e.currentTarget as HTMLElement).style.boxShadow = 'none';
              }}
            >
              <div className="ms-tool-card__glow" style={{ background: `radial-gradient(circle, ${tool.color}15, transparent)` }} />
              <div className="ms-tool-card__icon">{tool.icon}</div>
              <div className="ms-tool-card__name">{tool.name}</div>
              <div className="ms-tool-card__desc">{tool.desc}</div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
